import React, { useContext } from 'react';
import { UserInfoAction } from './reducer';
import { UserInfo } from '../models/UserInfo';

export type UserInfoContext = {
  state: UserInfo;
  dispatch: React.Dispatch<UserInfoAction>;
};

export const UserInfoContext = React.createContext<UserInfoContext | null>(
  null,
);

export const useUserInfoContext: () => [
  UserInfo,
  React.Dispatch<UserInfoAction>,
] = () => {
  const context = useContext(UserInfoContext);
  if (!context) {
    throw new Error('Context not found' + UserInfoContext);
  }
  return [context.state, context.dispatch];
};

export const useUserInfo: () => UserInfo = () => {
  const [state] = useUserInfoContext();
  return state;
};
